import type { TSuggestionText } from '@alpod-ai-writer/plate-plugins/suggestion';
import { cn } from '@udecode/cn';
import {
    PlateLeaf,
    type PlateLeafProps,
    useEditorPlugin,
    usePluginOption,
} from '@udecode/plate/react';

import { suggestionPlugin } from '../../plugins/suggestionPlugin';

export function SuggestionLeaf(props: PlateLeafProps) {
    const { children, className, leaf } = props;

    const { api } = useEditorPlugin(suggestionPlugin);

    const activeSuggestionId = usePluginOption(suggestionPlugin, 'activeId');
    const dataList = api.suggestion.dataList(leaf as TSuggestionText);

    const hasRemove = dataList.some((data) => data.type === 'remove');
    const hasActive = dataList.some((data) => data.id === activeSuggestionId);

    const diffOperation = {
        type: hasRemove ? 'delete' : 'insert',
    } as const;

    const Component = (
    {
        delete: 'del',
        insert: 'ins',
        update: 'span',
    } as const
    )[diffOperation.type];

    return (
        <PlateLeaf
            {...props}
            as={Component}
            className={cn(
                'border-b-2 border-b-blue-400 bg-blue-500/[.08] text-blue-800 no-underline transition-colors duration-200',
                !hasRemove && 'hover:border-b-blue-500 hover:bg-blue-100',
                hasActive && !hasRemove && 'border-b-blue-500 bg-blue-100',
                hasRemove && 'border-b-red-400 bg-red-200/25 text-red-800 line-through hover:border-b-red-500 hover:bg-red-100 hover:text-red-800 hover:no-underline',
                hasActive && hasRemove && 'border-b-red-500 bg-red-100 text-red-800 no-underline',
                className
            )}
        >
            {children}
        </PlateLeaf>
    );
}
